import { toast } from "sonner";

export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4001/api";
export const apiV1 = (path, options = {}) => api(`/v1${path}`, options);

function requestId() {
  return (
    window.crypto?.randomUUID?.() ||
    `web-${Date.now()}-${Math.random().toString(36).slice(2)}`
  );
}

export async function api(path, options = {}) {
  const token = localStorage.getItem("queme_token");
  const { idempotencyKey, ...fetchOptions } = options;
  const headers = {
    "Content-Type": "application/json",
    "X-Request-Id": requestId(),
    ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
    ...(fetchOptions.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  let response = await fetch(`${API_URL}${path}`, { ...fetchOptions, headers });
  if (
    response.status === 401 &&
    !path.includes("/auth/") &&
    localStorage.getItem("queme_refresh_token")
  ) {
    const refreshResponse = await fetch(`${API_URL}/v1/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Request-Id": requestId(),
      },
      body: JSON.stringify({
        refreshToken: localStorage.getItem("queme_refresh_token"),
      }),
    });
    if (refreshResponse.ok) {
      const refreshed = await refreshResponse.json();
      localStorage.setItem("queme_token", refreshed.token);
      headers.Authorization = `Bearer ${refreshed.token}`;
      response = await fetch(`${API_URL}${path}`, { ...fetchOptions, headers });
    } else {
      localStorage.removeItem("queme_token");
      localStorage.removeItem("queme_refresh_token");
      localStorage.removeItem("queme_session_id");
    }
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || "Something went wrong.");
    error.status = response.status;
    error.code = data.error;
    error.requestId = response.headers.get("X-Request-Id");
    toast.error(error.message);
    throw error;
  }
  return data;
}

export async function upload(path, file, field = "image", options = {}) {
  const token = localStorage.getItem("queme_token");
  const tenantId = options.tenantId || options.user?.tenantId || "";
  const form = new FormData();
  form.append(field, file);
  if (options.kind) form.append("kind", options.kind);
  const response = await fetch(`${API_URL}${path}`, {
    method: "POST",
    body: form,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "X-Request-Id": requestId(),
      "X-Correlation-ID": requestId(),
      ...(tenantId ? { "X-Tenant-ID": tenantId, "x-company-slug": tenantId } : {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || "Image upload failed.");
    toast.error(error.message);
    throw error;
  }
  return data;
}
